import { personalizedResource } from '@/lib/resources/personalized-resource';

// types
import type { ContentServiceVideoObject } from '@/lib/types/api/content-service'

// Distinct from the `viewing-history` percentage atom: these are complete video
// objects, needed by the My List viewing history page.
export const myListViewingHistory = personalizedResource<ContentServiceVideoObject>({
  key: 'myListViewingHistory',
  endpoint: '/api/profile/viewing-history/',
  select: (json) => (json as { myListViewingHistoryData: ContentServiceVideoObject[] | null }).myListViewingHistoryData,
})
